export default __webpack_public_path__ + "static/media/myCompanyIco.529ea8d5.svg";